<template>
  <v-row>
    <v-col cols="12" sm="6">
      <h6>{{ $t("list.name") }}</h6>
      <v-text-field
        density="compact"
        v-model="nameTH"
        :rules="rules"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <h6>{{ $t("list.surname") }}</h6>
      <v-text-field
        density="compact"
        v-model="surnameTH"
        :rules="rules"></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import validator from "@/helper/validator";
export default {
  name: "nameTHCard",
  props: {
    modelValue: Object,
  },
  data: () => ({
    rules: [validator.required],
  }),

  computed: {
    nameTH: {
      get() {
        return this.modelValue.nameTH;
      },
      set(value) {
        this.$emit("update:modelValue", {
          nameTH: value,
          surnameTH: this.surnameTH,
        });
      },
    },

    surnameTH: {
      get() {
        return this.modelValue.surnameTH;
      },
      set(value) {
        this.$emit("update:modelValue", {
          nameTH: this.nameTH,
          surnameTH: value,
        });
      },
    },
  },
};
</script>
